import React from 'react';

import Plugin from '../../modules/plugin-modules';

const importLogo = props => {
  return <Plugin.Logo />
}

export default importLogo;
